<template>
  <div class="innovate">
    <div class="head-img">
      <div class="title">Precise Planning <br> In-depth Operation</div>
      <div class="title2">Precise Planning<br>In-depth Operation</div>
    </div>
    <div class="innovate-menu">
      <div class="menu-head">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>Service</el-breadcrumb-item>
          <el-breadcrumb-item>{{BreadText}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="gundong">
        <ul class="menu-content">
          <li v-for="item in innovateMenu" :key="item.id" :class="inRouter == item.name?'innovate-gl':''">
            <router-link :to="{name:item.name}">{{item.text}}
            </router-link>
          </li>
        </ul>
      </div>

    </div>
    <transition enter-active-class="animate__animated animate__fadeIn">
      <router-view />
    </transition>
  </div>
</template>

<script>

export default {
  data() {
    return {
      innovateMenu: [
        {
          id: 1,
          text: 'Work with primary-level governments',
          name: 'jiceng'
        },
        {
          id: 2,
          text: 'Setting up of Hemodialysis Unit',
          name: 'touxi'
        },
        {
          id: 3,
          text: 'self-media brands operation',
          name: 'doctorIP'
        }, {
          id: 4,
          text: 'Advertisement of hospital departments',
          name: 'kexue'
        }, {
          id: 5,
          text: 'Digital Marketing',
          name: 'shuzi'
        },
        {
          id: 6,
          text: 'strange land Hemodialysis',
          name: 'yidi'
        }
      ],
      inRouter: this.$router.history.current.name,
      BreadText: this.$router.history.current.meta.title || ''
    }
  },
  watch: {
    $route(to) {
      let newpath = to.path.slice(1).split('/')[1]
      this.inRouter = newpath
      let MybreadText = this.innovateMenu.filter(item => {
        return item.name == newpath
      })
      this.BreadText = MybreadText[0].text
    }
  },
  created() {
  },
  mounted() {
    // const that = this
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.body.clientWidth
    //     that.screenWidth = window.screenWidth
    //   })()
    // }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.innovate {
  .innovate-gl {
    color: #0ca6eb !important;
    // padding: 0.4737rem 0 0.3789rem 0;
    border-bottom-color: #0ca6eb !important;
    z-index: 99999;
    a {
      color: #0ca6eb !important;
    }
  }

  width: 100%;
  .head-img {
    height: 5.2632rem;
    background: url('../../assets/image/innovatc/head.webp') no-repeat;
    background-size: 100% 100%;
    position: relative;
    @media screen and (max-width: 540px) {
      height: 12.6316rem;
      background: url('../../assets/image/innovatc/headios.png') no-repeat;
      background-size: 100% 100%;
    }
    .title2 {
      display: none;
      @media screen and (max-width: 540px) {
        display: block;
        position: absolute;
        right: 4%;
        top: 45%;
        font-size: 18px;
        color: #272b2d;
        line-height: 1.5789rem;
        font-weight: 600;
      }
    }
    .title {
      position: absolute;
      top: 2.3158rem;
      right: 5.0526rem;
      font-size: 0.4211rem;
      font-weight: 700;
      color: #272b2d;
      letter-spacing: 3.64px;
      @media screen and (max-width: 540px) {
        display: none;
      }
    }
  }

  .innovate-menu {
    height: 1.1789rem;
    margin: 0 0.8421rem;
    position: relative;
    display: flex;
    // justify-content: center;
    padding: 0 0.1316rem;
    align-items: center;
    @media screen and (max-width: 540px) {
      margin: 0;
      height: 60px;
    }
    .menu-head {
      padding-right: 0.6316rem;
      width: 4.6316rem;
      font-size: 0.2105rem !important;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-breadcrumb {
        font-size: 0.1895rem;
      }
    }
    .gundong::-webkit-scrollbar {
      display: none;
    }
    .gundong {
      height: 100%;
      @media screen and (max-width: 540px) {
        overflow: scroll;
        overflow-y: hidden;
      }
      .menu-content {
        display: flex;
        height: 100%;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          margin: 0 0.1737rem;
          font-size: 0.2105rem;
          box-sizing: border-box;
          border-bottom: 6px solid #0ca4eb00;
          @media screen and (max-width: 540px) {
            flex: 1;
            font-size: 13px;
            margin: 0 5px;
          }
          a {
            width: 150px;
            font-weight: 700;
            text-align: center;
            list-style: none;
            color: #666666;
            // padding: 0.4737rem 0 0.4842rem 0;
            // @media screen and (max-width: 540px) {
            //   padding: 0.9474rem 0;
            // }
          }
        }
      }
    }
  }
  .innovate-menu::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    border-radius: 0.0316rem;
    background-color: #f1f1f1;
  }
}
</style>
